// @flow
import type { Message } from 'mz-intl'
import messages from '../../messages.intl'

// Types
export type StripeErrorType = {
  code: string,
  message: string,
}

export const ERROR_CODES = {
  unable_create_reservation: 'UNABLE_CREATE_RESERVATION',
}

/**
 * Extended reservation error
 * @param {string} code Code
 */
export class ReservationError extends Error {
  code: string

  message: string

  i18n: Message

  constructor(code: $Values<typeof ERROR_CODES>) {
    super()
    const normCode = code.toUpperCase()
    const message = messages[normCode]

    this.code = normCode
    this.message = message.defaultMessage
    this.i18n = message
  }
}

export default ReservationError
